<template src="./warn-close-modal.html"></template>

<script lang="ts">
import { nextTick } from 'vue'
import Header from 'objects/header/Header.vue'
import Modal from 'objects/modal/Modal.vue'


export default {
  name: 'WarnCloseModal',
  emits: ['close', 'closeParentModal'],
  components: {
    'tt-header': Header,
    'tt-modal': Modal
  },
  methods: {
    close() {
      this.$emit('close')
    },
    closeParentModal() {
      this.$emit('closeParentModal')
    }
  },
  mounted() {
    nextTick(() => this.$refs.returnBtn.$el.focus())
  }
}
</script>

<style lang="scss" src="./warn-close-modal.scss"></style>
